import { ConsultationChatContainer } from '../containers/ConsultationChatContainer/index'

export const ConsultationChatPage = ({numberOfPage, setNumberOfPage}) => (
    <ConsultationChatContainer numberOfPage={numberOfPage} setNumberOfPage={setNumberOfPage}/>
)